<template>
    <el-dialog title="提示" :visible.sync="innerVisible" class="dialog-table" width="500px" :before-close="closeDialogPop">
        <div>
            这是代理商页面，请勿操作。如需设置{{$route.name}}，请先创建一个代理商账号，再登录代理商账号进行添加。即将前往【代理商账号】页面
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="popSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        name: 'AgentPop',
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            agentSetTitle: String
        },
        data() {
            return {
                innerVisible: this.visible
            }
        },
        watch: {
            visible(newValue) {
                this.innerVisible = newValue;
                // this.$nextTick(()=>{
                //     this.$refs.singleTable.setCurrentRow(this.selectApp)
                // })
            },
            innerVisible(newValue) {
                this.$emit('update:visible', newValue);
            }
        },
        mounted() {
            // console.log(this.$route)
        },
        methods: {
            // 确定按钮
            popSureBtn() {
                this.goAgent()
            },
            // 关闭弹框
            closeDialogPop () {
                this.goAgent()
            },
            goAgent(){
                // console.log(111)
                // window.location.href ='/agent-account'
                this.$router.push({ path: '/agent-account'})
            }
        }
    }
</script>
